import axios from "../assets/vendor/axios";

export default window.axios = axios;
